import React, { useEffect } from 'react';
import './Refundpolicy.css';
import Navigation from '../components/Navbar';
import Footer from '../components/Footer';
import Scrolltop from '../components/Scrolltop';
import WhatsAppChatButton from '../components/Whatsapp';

const RefundPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);
  return (
    <>
    <Navigation />  
    <div className="refund-container">
      <h1>Refund Policy</h1>
      
      <section>
        <h2>1. Introduction</h2>
        <p>
          We value your trust and aim to provide excellent service. Our refund policy ensures transparency in all financial transactions. Please read this policy carefully before availing of our services.
        </p>
      </section>
      
      <section>
        <h2>2. Applicability</h2>
        <p>
          This refund policy applies to all services offered by us. Refunds, cancellations, and rescheduling are subject to the terms outlined below.
        </p>
      </section>
      
      <section>
        <h2>3. Eligibility for Refund</h2>
        <p>
          Refunds will only be considered under the following circumstances:
        </p>
        <ul>
          <li>
            The service has not been initiated, and you request a cancellation within 24 hours of payment.
          </li>
          <li>
            The service cannot be delivered due to technical or operational issues from our side.
          </li>
          <li>
            Duplicate payments made due to technical errors. In such cases, the duplicate payment will be refunded after verification.
          </li>
        </ul>
      </section>
      
      <section>
        <h2>4. Non-Refundable Cases</h2>
        <p>
          Refunds will not be provided under the following circumstances:
        </p>
        <ul>
          <li>
            If the service has been initiated, partially completed, or delivered as per the agreed scope of work.
          </li>
          <li>
            If the delay in service is due to incomplete or inaccurate information provided by you.
          </li>
          <li>
            For changes in scope after the service has commenced, unless agreed upon with additional charges.
          </li>
          <li>
            If legal or regulatory constraints arise that prevent the continuation of the service.
          </li>
          <li>
            Dissatisfaction arising from subjective preferences or expectations not explicitly agreed upon during the engagement.
          </li>
        </ul>
      </section>
      
      <section>
        <h2>5. Refund Process</h2>
        <p>
          To request a refund, please contact us via email at <strong>info@krinvy.com</strong> with the following details:
        </p>
        <ul>
          <li>Your full name and contact information</li>
          <li>Order ID or transaction details</li>
          <li>Reason for refund request</li>
          <li>Any supporting documentation (if applicable)</li>
        </ul>
        <p>
          Refund requests will be reviewed within 5-7 business days. If approved, the refund will be processed within 10 business days and credited back to the original payment method.
        </p>
      </section>
      
      <section>
        <h2>6. Partial Refunds</h2>
        <p>
          In cases where the service is partially completed, we may offer a partial refund proportional to the work that remains undone. The final amount will be determined after internal assessment.
        </p>
      </section>
      
      <section>
        <h2>7. Cancellation Policy</h2>
        <p>
          Cancellations are allowed only for services that have not been initiated. If you wish to cancel your order, you must do so within 24 hours of payment. Cancellation requests after this time may not be eligible for refunds.
        </p>
      </section>
      
      <section>
        <h2>8. Force Majeure</h2>
        <p>
          We shall not be held responsible for delays, interruptions, or failures in service due to events beyond our reasonable control, including but not limited to natural disasters, government regulations, or technical failures. Refunds will not be provided in such cases.
        </p>
      </section>
      
      <section>
        <h2>9. Changes to the Refund Policy</h2>
        <p>
          We reserve the right to update or modify this refund policy at any time. Any changes will be effective immediately upon posting on our website. Clients are advised to review the policy periodically.
        </p>
      </section>
      
      <section>
        <h2>10. Governing Law</h2>
        <p>
          This refund policy is governed by and construed in accordance with the laws of India. Any disputes arising from this policy will be subject to the jurisdiction of courts in your operating city.
        </p>
      </section>
    </div>
    <Scrolltop />
    <WhatsAppChatButton />
    <Footer />
    </>
  );
};

export default RefundPolicy;
